import { api_config } from "utils/APIConfig";
import { ACTION_GET, ACTION_POST } from "utils/AxiosActions";

export const Profile_Info = async (token) => {
  const auth = await api_config();
  auth.config.headers['Authorization'] = `Bearer ${token}`
  const url = `${auth.mypage_host}/profile/`;
  const config = auth.config;

  return new Promise((resolve, reject) => {
    ACTION_GET(url, config)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const Profile_Update = async (data, token) => {
  const auth = await api_config()
  auth.config.headers['Authorization'] = `Bearer ${token}`

  const url = `${auth.mypage_host}/profile/`;
  const result = await ACTION_POST(url, data, auth.config);
  if (result) {
    return result;
  }
};

// 前回の郵便番号を記憶（変更検知用）
let lastZipcode = '';

/**
 * 郵便番号から住所を自動補完する関数
 * @param {Object} form - React-JSON-Schema-FormのonChangeで渡されるformオブジェクト
 * @param {Function} setFormDataCallback - React stateを更新するためのコールバック（オプション）
 */
export const AutoComplete_ZipCode = (form, setFormDataCallback) => {
  let formHasCustomData = !!form.formData.custom_data?.zipcode;

  let zipcode = form.formData.custom_data?.zipcode || form.formData.zipcode;

  const zipcodeId = form.idSchema.custom_data?.zipcode?.$id || form.idSchema.zipcode?.$id;
  const prefCodeId = form.idSchema.custom_data?.prefCode?.$id || form.idSchema.prefCode?.$id;
  const cityId = form.idSchema.custom_data?.city?.$id || form.idSchema.city?.$id;
  if (zipcode && prefCodeId && cityId) {
    zipcode = zipcode.replaceAll(/[^\d]/g, '') // Replace Non digit string
    // 郵便番号が7桁かつ前回と異なる場合に自動補完を実行
    // （都道府県が設定済みでも、郵便番号が変更されたら補完する）
    if (zipcode.length === 7 && zipcode !== lastZipcode) {
      lastZipcode = zipcode; // 次回比較用に保存
      // Call postcode to address API
      // Ref => https://postcode.teraren.com/doc
      ACTION_GET('https://postcode.teraren.com/postcodes/' + zipcode + '.json', {})
            .then((result) => {
              const options = document.querySelectorAll('#' + prefCodeId + ' option');
              const matchedOption = Array.from(options).find(option => option.text === result.prefecture);

              // DOM更新（表示用）
              document.querySelector('#' + zipcodeId).value = zipcode;
              document.querySelector('#' + prefCodeId).value = matchedOption?.value;
              document.querySelector('#' + cityId).value = result.city + result.suburb;

              // formData直接更新（後方互換性のため維持）
              if (formHasCustomData) {
                form.formData.custom_data.zipcode = zipcode;
                form.formData.custom_data.prefCode = matchedOption?.value;
                form.formData.custom_data.city = result.city + result.suburb;
              } else {
                form.formData.zipcode = zipcode;
                form.formData.prefCode = matchedOption?.value;
                form.formData.city = result.city + result.suburb;
              }

              // React state更新（コールバックが提供されている場合）
              if (setFormDataCallback && typeof setFormDataCallback === 'function') {
                const updatedFormData = { ...form.formData };
                if (formHasCustomData) {
                  updatedFormData.custom_data = {
                    ...updatedFormData.custom_data,
                    zipcode: zipcode,
                    prefCode: matchedOption?.value,
                    city: result.city + result.suburb
                  };
                } else {
                  updatedFormData.zipcode = zipcode;
                  updatedFormData.prefCode = matchedOption?.value;
                  updatedFormData.city = result.city + result.suburb;
                }
                setFormDataCallback(updatedFormData);
              }
            })
            .catch((error) => {
                console.log(error);
            });
    }
  }
}